import { useQuery, useMutation } from "@tanstack/react-query";
import {
  fetch2,
  fetch3,
  fetch4,
  fetch5,
  fetch6,
} from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

type ClientData = {
  name: string;
  mobileNo: string;
  email: string;
  contactType: string;
  vatNumber: string;
  nationalId: string;
  nationalCopy: string;
  country: string;
  hub: string;
  city: string;
  paymentTerm: string;
  access: string;
  location: string;
  status?: string;
  crCopy?: File | any;
  vatDocument?: File | any;
  companyLogo?: File | any;
  contractDocument?: File | any;
};

type ClientStatus = {
  status: string;
};

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
  statusCode?: number;
  statusMessage?: string;
  error?: any;
}

export const useClientCreateMutation = () => {
  return useMutation({
    mutationFn: async (payload: ClientData) => {
      const res: ApiResponse = await fetch2(`${url}/api/lm-client?type=lmClient`, payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Staff Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ staff create request failed:", error.message);
    },
  });
};

export const useClientListData = (page: number, searchFor: string) => {
  return useQuery({
    queryKey: ["clientList"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/lm-client?page=${page}&searchFor=${searchFor}&type=lmClient`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useClientAllListData = () => {
  return useQuery({
    queryKey: ["clientAllList"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/lm-client/all`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchClientSingleData = (id: string) => {
  return useQuery({
    queryKey: ["singleClientData"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/lm-client/get-single-client/${id}?type=lmClient`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useClientUpdateMutation = (id: string) => {
  return useMutation({
    mutationFn: async (payload: ClientData) => {
      const res: ApiResponse = await fetch6(
        `${url}/api/lm-client/${id}?type=lmClient`,
        payload
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Staff Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ staff create request failed:", error.message);
    },
  });
};

export const useClientStatusMutation = (id: string) => {
  return useMutation({
    mutationFn: async (payload: ClientStatus) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/lm-client/status/${id}?type=lmClient`,
        "PATCH",
        payload
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Staff Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ staff create request failed:", error.message);
    },
  });
};

export const useClientDeleteMutation = (id: string) => {
  return useMutation({
    mutationFn: async () => {
      const res: ApiResponse = await fetch5(
        `${url}/api/lm-client/delete-client/${id}?type=lmClient`,
        "DELETE"
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Staff Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ staff create request failed:", error.message);
    },
  });
};
